import { Component, useEffect, useRef } from "react";
import Lenis from "lenis";
import Ambient from "@/components/Ambient";
import MusicToggle from "@/components/MusicToggle";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Details from "@/components/Details";
import Rsvp from "@/components/Rsvp";
import "@/App.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-line">
        <strong>Ginevra Mosi</strong> — Chapter Eighteen
      </div>
    </footer>
  );
}

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollToDetails = () => {
    const target = "#dettagli";
    if (lenisRef.current) lenisRef.current.scrollTo(target, { duration: 1.4 });
    else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <ErrorBoundary>
      <div className="site">
        <Ambient />
        <MusicToggle />
        <main>
          <Hero onScrollHint={scrollToDetails} />
          <Marquee />
          <Details />
          <Rsvp />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}
